import axios from 'axios';

// Field Staff Management backend
// Use main backend with /api prefix
const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('field_staff_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('field_staff_token');
      localStorage.removeItem('field_staff_user');
      window.location.href = '/field-staff/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper functions
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('field_staff_user');
  return userStr ? JSON.parse(userStr) : null;
};

export const logout = () => {
  localStorage.removeItem('field_staff_token');
  localStorage.removeItem('field_staff_user');
  window.location.href = '/field-staff/login';
};

export const hasPermission = (permission) => {
  const user = getCurrentUser();
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  return user.permissions?.[permission] || false;
};
